export const cvData = [

  {id: 10,
  date: 'Jun 2026 - Present',
  affair: 'UX/UI Design Intern',
company:'WeAreFirma',
description: '',
link:'https://www.wearefirma.com/es',
type: 'experience',
},
  {id: 9,
  date: 'Apr 2026 - Present',
  affair: 'UI Artist',
company:'Ravenwhisp Studios',
description: 'Creating the game UI for the videogame Bound by Death',
link:'https://ravenwhisp.github.io/Ravenwhisp/#home',
type: 'experience',
},

  {
  id: 1,
  date: 'Jun 2024 - Sep 2024',
  affair: 'Digital Product Designer Intern',
  company: 'The North Studio',
  description: `Developed UI designs for Grup NN websites.
Established prototypes and animations with Figma.
Tested and documented Google Maps API integrations.
Uploaded text and image content into Sanity CMS.`,
link:'https://thenorthstudio.com/',
  type: 'experience',
},

  {
  id: 2,
  date: '2024 - 2025',
  affair: 'Graphic Designer',
  company: 'Farmàcia Isabel Tell',
  description: `Created Visual Identity and necessary elements.`,
  type: 'experience',
},

  {
  id: 3,
  date: '2023 - 2024',
  affair: 'Creation Lab with 3Cat',
  company: 'Asociated with Corporació Catalana de Mitjans Audiovisuals and CITM',
  description: `Ideated a gamified experience for the 3Cat streaming platform.  
Prototyped and designed UI with Figma.`,
  type: 'experience',
},

  {
  id: 4,
  date: '2023',
  affair: 'Giravolt Crealab Project',
  company: 'Asociated with Agencia de Patrimoni Cultural and CITM',
  description: `Initiated a game design document.  
Designed UI HUD and Visual Identity for a VR video game.  
Modeled and texturized assets with Maya and Substance Painter`,
  type: 'experience',
},

  {
  id: 6,
  date: 'Apr 2026 - In progress',
  affair: 'Master’s UX in Digital Product Design',
  company: 'ESDI X NTT DATA',
  description: ``,
  type: 'education',
},

  {
  id: 7,
  date: 'Sept 2021 - Jul 2025',
  affair: 'Multimedia Degree',
  company: 'CITM UPC',
  description: ``,
  type: 'education',
},

  {
  id: 8,
  date: 'Sept 2025 - In progress',
  affair: 'Foundations of User Experience (UX) Design',
  company: 'Google (Coursera)',
  description: ``,
  type: 'education',
}

]
